import { render, staticRenderFns } from "./TugBoatMaster.vue?vue&type=template&id=58f895d4&scoped=true&"
import script from "./TugBoatMaster.vue?vue&type=script&lang=js&"
export * from "./TugBoatMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f895d4",
  null
  
)

export default component.exports